<template>
    <header
        v-bind:class="{ 'header--aside': menu }"
        class="header">
        <div 
            v-if="!back"
            class="header__hamburger"
            v-bind:class="{ 'header__hamburger--open': menu }"
            v-on:click.prevent="$emit('toggleMenu')">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <router-link v-if="!back" to="/" class="header__brand">
            Drømmen om det gode
        </router-link>
        <router-link 
            v-else 
            :to="'/' + back"
            class="header__back">
            <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
            </svg>
            <span>Tilbake</span>
        </router-link>
        <a v-if="canAddToFavorites && !back" v-on:click.prevent="favorite ? removeFromFavorites() : addToFavorite()" class="header__favorite">
            <svg-asset 
            v-bind:icon="favorite ? 'heart-solid' : 'heart-outline'"></svg-asset>
        </a>
    </header>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import SvgAsset from '@/components/SvgAsset';

    export default {
        name: 'Header',
        computed: mapState([
            'menu',
            'back',
            'canAddToFavorites',
            'favorite'
        ]),
        components: {
            SvgAsset
        },
        methods: {
            ...mapActions([
                'hideMenu',
                'addToFavorite',
                'removeFromFavorites']),
        },
    };
</script>

<style lang="scss">
    .header {
        display:flex;
        align-items: center;
        z-index: 99;

        position: fixed;
        left:0;
        width: 100%;

        padding:10px;

        color:#fff;
        background-color: #dca83f;
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.3);

        &__hamburger {
            position: relative;
            z-index: 101;

            width: 24px;
            height: 20px;
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: .5s ease-in-out;
            -moz-transition: .5s ease-in-out;
            -o-transition: .5s ease-in-out;
            transition: .5s ease-in-out;
            cursor: pointer;

            span {
                display: block;
                position: absolute;
                height: 3px;
                width: 100%;
                background: #fff;
                border-radius: 9px;
                opacity: 1;
                left: 0;
                transform: rotate(0deg);
                transition: .25s ease-in-out;
            }
            span:nth-child(1) {
                top: 0px;
            }
            span:nth-child(2),
            span:nth-child(3) {
                top: 8px;
            }
            span:nth-child(4) {
                top: 16px;
            }
        
            &--open {
                span:nth-child(1) {
                    top: 8px;
                    width: 0%;
                    left: 50%;
                }
                span:nth-child(2) {
                    -webkit-transform: rotate(45deg);
                    -moz-transform: rotate(45deg);
                    -o-transform: rotate(45deg);
                    transform: rotate(45deg);
                }
                span:nth-child(3) {
                    -webkit-transform: rotate(-45deg);
                    -moz-transform: rotate(-45deg);
                    -o-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                }
                span:nth-child(4) {
                    top: 8px;
                    width: 0%;
                    left: 50%;
                }
            }
        }

        &__brand {
            flex-grow: 1;
            margin-left:15px;
            color:#fff;
            text-decoration: none;
        }

        &__back {
            display: flex;
            align-items: center;
            margin-left:0;
            color:#fff;

            svg {
                width:20px;
                height:24px;
                margin-right:10px;
            }
        }

        &__favorite {
            cursor:pointer;

            span {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            svg {
                width:22px;
                height:22px;
            }            
        }
    }
</style>
